/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "360D01BB-34B8-46BC-B5BD-9FFFD7D289BF",
  "sitecoreApiHost": "https://developer.arm.com/",
  "jssAppName": "Developer2-0",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/Developer2-0",
  "REACT_APP_AI_ASSISTANCE_ENABLED": "true",
  "REACT_APP_ARM_GLOBALNAVIGATION_HOST": "https://www.arm.com",
  "REACT_APP_ATM_HOSTNAME": "https://developer.arm.com",
  "REACT_APP_AUTH_SIGN_IN_URL": "sign-in",
  "REACT_APP_AUTH_SILENT_SIGN_IN_URL": "silent-sign-in",
  "REACT_APP_CACHE_STORAGE_KEY": "entitlements-cache",
  "REACT_APP_CHECK_ENTITLEMENTS_ENABLED": "true",
  "REACT_APP_COMMUNITYBLOGS": "https://developer.arm.com/api/CommunityBlogs",
  "REACT_APP_COMMUNITYFORUM": "https://developer.arm.com/api/CommunityForums",
  "REACT_APP_CONTENTHOME_PATH": "/sitecore/content/Developer2-0/Home",
  "REACT_APP_COOKIEDATASOURCE": "F44CCA02-E7FF-4078-B886-CF1B3256A9CD",
  "REACT_APP_COOKIEDOMAIN": ".arm.com",
  "REACT_APP_COOKIEENPOINT": "//api/cookies-policy/",
  "REACT_APP_COVEOCACHEDENDPOINT": "https://developer.arm.com/external-api/coveo/rest/search/v2",
  "REACT_APP_COVEOCOMMUNITYQUERYPIPELINE": "Community",
  "REACT_APP_COVEOCOMMUNITYRECOMMENDEDQUERYPIPELINE": "Community-Recommended",
  "REACT_APP_COVEOCOMMUNITYSEARCHHUB": "Community",
  "REACT_APP_COVEOGETSEARCHTOKENURL": "https://api2.arm.com",
  "REACT_APP_COVEOHOMEPAGECOMMUNITYQUERYPIPELINE": "Dev2RecommendationTest",
  "REACT_APP_COVEOHOMEPAGECOMMUNITYSEARCHHUB": "CommunityRecommendationsTest",
  "REACT_APP_COVEOHOMEPAGEDOCUMENTATIONQUERYPIPELINE": "Dev2RecommendationTest",
  "REACT_APP_COVEOHOMEPAGEDOCUMENTATIONSEARCHHUB": "Dev2HomepageDocumentationTest",
  "REACT_APP_COVEOHOMEPAGERECOMMENDEDPIPELINE": "Dev2HomepageRecommendations",
  "REACT_APP_COVEOHOMEPAGERECOMMENDEDSEARCHHUB": "Dev2HomepageRecommendations",
  "REACT_APP_COVEOHOMEPAGESEARCHBOXQUERYPIPELINE": "Developer_sc103",
  "REACT_APP_COVEOHOMEPAGESEARCHBOXSEARCHHUB": "arm_developer_sc103",
  "REACT_APP_COVEOKEYRESOURCESTABID": "KeyResourcesTab",
  "REACT_APP_COVEOLANDINGPAGEQUERYPIPELINE": "Dev2FilterandSearch_sc103",
  "REACT_APP_COVEOORGANIZATIONID": "armlimitednonproduction1fndbai7e",
  "REACT_APP_COVEOPRODUCTPAGEQUERYPIPELINE": "Dev2ProductPage",
  "REACT_APP_COVEOPRODUCTPAGERECOMMENDATIONQUERYPIPELINE": "Dev2ProductPageRecommendation_sc103",
  "REACT_APP_COVEOPRODUCTPAGERECOMMENDATIONSEARCHHUB": "Dev2ProductPageRecommendation_sc103",
  "REACT_APP_COVEOPRODUCTPAGESEARCHHUB": "Dev2ProductPage",
  "REACT_APP_COVEORESOURCESTABID": "ResourcesTab",
  "REACT_APP_COVEOSEARCHPAGE": "https://developer.arm.com",
  "REACT_APP_COVEO_COMMUNITY_SOURCE": "prod-community-index",
  "REACT_APP_COVEO_DOCUMENT_SOURCE": "uat-document-service-index",
  "REACT_APP_DYNATRACE_CONFIG": "16827775e4e/bf61363iak/58aba1a497f86e50",
  "REACT_APP_EA_HOSTNAME": "developer.arm.com",
  "REACT_APP_ENCRYPTIONKEY": "99e4bbfaf97d99ca826d0543eb16f6e0647dc8d7726517b854621b97b213cd18",
  "REACT_APP_ENTITLEMENTS_BASE_URL": "https://api2.arm.com",
  "REACT_APP_ENTITLEMENTS_CACHE_TTL_MINS": "30",
  "REACT_APP_ERROR_PAGE_BLOGS_LINK": "https://community.arm.com/developer/b",
  "REACT_APP_ERROR_PAGE_DEVELOPER_HOME_LINK": "https://developer.arm.com",
  "REACT_APP_ERROR_PAGE_DOCUMENTATION_LINK": "https://developer.arm.com/documentation/",
  "REACT_APP_FETCH_WITH": "GRAPHQL",
  "REACT_APP_FOOTERDOMAINURL": "https://developer.arm.com",
  "REACT_APP_FOOTERSITECOREDATASOURCE": "841ADC3D-FCB0-4E8C-BB28-31BD9C040F13",
  "REACT_APP_FOOTERSITECOREENDPOINT": "//api/footer/",
  "REACT_APP_GLOBALNAVSITECOREDATASOURCE": "AD9391BD-0C81-4775-9104-8477F47EA6AB",
  "REACT_APP_GLOBALNAVSITECOREENDPOINT": "//api/global-navigation/",
  "REACT_APP_MEDALLIAFEEDBACKFORMID": "7336",
  "REACT_APP_MEDALLIARATINGFORMID": "7859",
  "REACT_APP_MSAL_B2C_HOST": "account.arm.com",
  "REACT_APP_MSAL_CLIENT_ID": "cc224ba8-a250-481d-8123-4d115a073c4c",
  "REACT_APP_MSAL_LOGOUT_URL": "/logout",
  "REACT_APP_MSAL_POLICY": "B2C_1A_OPEN_EMB_SUSI",
  "REACT_APP_MSAL_REDIRECT_PATH": "/auth-callback",
  "REACT_APP_MSAL_SCOPE": "openid",
  "REACT_APP_MSAL_TENANT": "armb2c.onmicrosoft.com",
  "REACT_APP_ORIGIN": "https://developer.arm.com",
  "REACT_APP_OTLP_API_URL": "https://developer.arm.com/otel/collect/v1/traces",
  "REACT_APP_PATHNAME": "/",
  "REACT_APP_SECURITYCENTERQUERYPIPELINE": "Dev2ArmSecurityCenter",
  "REACT_APP_SECURITYCENTERSEARCHHUB": "Dev2ArmSecurityCenter",
  "REACT_APP_SFA_AUTHORITY": "https://account.arm.com/tfp/armb2c.onmicrosoft.com/B2C_1A_arm_accounts_public.susi/v2.0/",
  "REACT_APP_SFA_CLIENT_ID": "b7705cd8-fe14-4c60-9b70-a583ffad84ee",
  "REACT_APP_SFA_SCOPE": "openid https://armb2c.onmicrosoft.com/developer/read",
  "REACT_APP_SITECORELAYOUTURI": "https://developer.arm.com",
  "REACT_APP_SITECOREORIGIN": "https://developer.arm.com",
  "REACT_APP_SITECOREURI": "https://developer.arm.com/",
  "REACT_APP_SITECORE_NOTIFICATIONS_API": "https://api2.arm.com/e-armaccount/v2/notifications?limit=100",
  "REACT_APP_SITECORE_NOTIFICATIONS_LINK": "https://services.arm.com/support/s/notifications",
  "REACT_APP_SITECORE_PROFILE_LINK": "https://services.arm.com/support/s/profile/home?tabset-5f9eb=1",
  "REACT_APP_SITECORE_SETTINGS_LINK": " https://services.arm.com/support/s/profile/home?tabset-5f9eb=2",
  "REACT_APP_SUPPORT_ORIGIN": "https://support.arm.com",
  "REACT_APP_SUPPRESS_HYDRATION_WARNINGS": "true",
  "REACT_APP_THEME_TOGGLE": "true",
  "REACT_APP_USER_STORE_KEY": "user-store",
  "REACT_APP_VIRTUAL_FAE_APP_NAME": "supportHub-live",
  "REACT_APP_VIRTUAL_FAE_SCRIPT_URL": "https://content.ipexplorer.arm.com/VirtualFAE/support/chat-ai.js",
  "graphQLEndpoint": "https://developer.arm.com//api/Developer2-0?sc_apikey=360D01BB-34B8-46BC-B5BD-9FFFD7D289BF"
};